{
  "title": "Skywrite",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "2nd-level transmutation (ritual)",
  "level": 2,
  "castingTime": "1 action",
  "range": "Sight",
  "components": "V, S",
  "duration": "Concentration, up to 1 day",
  "description": [
    "You cause up to ten words to form in a part of the sky you can see. The words appear to be made of cloud and remain in place for the spell’s duration. The words dissipate when the spell ends. A strong wind can disperse the clouds and end the spell early."
  ],
  "spellLists": ["artificer", "bard", "druid", "wizard"]
}
